<!-- 注册 -->
<template>
  <div class="register">
    <!-- 导航栏 -->
    <van-nav-bar title="填写基本信息" fixed placeholder z-index="10" @click-left="goBack">
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
    </van-nav-bar>
    <!-- 列表页 -->
    <!-- 头像上传 -->

    <div style="height:2rem;padding-top:0.3rem">
      <van-uploader :after-read="afterRead" v-model="logoImg" :show-upload="upload" @delete="colse">
        <div class="add-img">
          <img src="@/assets/img/home/add.png" class="add" />
          <p>添加头像</p>
        </div>
      </van-uploader>
    </div>
    <!-- 姓名 -->

    <div class="list-item">
      <div class="item-top">
        <span>*</span>
        姓名
      </div>
      <input type="text" class="input" placeholder="请输入真实姓名" v-model="name" />
    </div>
    <!-- 性别 -->
    <div class="list-item">
      <div class="item-top">
        <span>*</span>
        性别
      </div>
      <van-radio-group v-model="radio" class="encrypt-right">
        <van-radio name="1">
          <span :class="radio==1?'checked':''">男</span>
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
        <van-radio name="2">
          <span :class="radio==2?'checked':''">女</span>
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
      </van-radio-group>
    </div>
    <!-- 民族 -->
    <div class="list-item">
      <div class="item-top">
        <span>*</span>
        民族
      </div>
      <input
        type="text"
        class="input"
        placeholder="请选填民族"
        readonly
        v-model="nation"
        @click="showPicker=true"
      />
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        value-key="name"
      />
    </van-popup>
    <!-- 政治面貌 -->
    <div class="list-item">
      <div class="item-top">
        <span>*</span>
        政治面貌
      </div>
      <input
        type="text"
        class="input"
        placeholder="请选填政治面貌"
        readonly
        v-model="politics"
        @click="identity=true"
      />
    </div>
    <van-popup v-model="identity" round position="bottom">
      <van-picker
        show-toolbar
        :columns="identityList"
        @cancel="identity = false"
        @confirm="identitySelect"
        value-key="name"
      />
    </van-popup>
    <!-- 身份证号码 -->
    <div class="list-item">
      <div class="item-top">
        <span>*</span>
        身份证号码
      </div>
      <input type="text" class="input" placeholder="请输入请输入18位身份证号码" v-model="idNum" />
    </div>
    <!-- 证件类型 -->
    <!-- <div class="list-item">
      <div class="item-top">
        <span>*</span>
        证件类型
      </div>
      <input
        type="text"
        class="input"
        placeholder="请选填证件类型"
        readonly
        v-model="certificate"
        @click="types=true"
      />
    </div>-->
    <!-- <van-popup v-model="types" round position="bottom">
      <van-picker show-toolbar :columns="typeList" @cancel="types = false" @confirm="typeSelect" />
    </van-popup>-->
    <!-- 电话号码 -->
    <div class="list-item" @click="checkArea">
      <div class="item-top">
        <span>*</span>
        所在地区
      </div>
      <input type="text" class="input" placeholder="请选择所在地区" :value="companyAddress[0]" readonly />
    </div>
    <div class="list-item">
      <div class="item-top">
        <span>*</span>
        详细住址
      </div>
      <input type="text" class="input" placeholder="请输入详细住址" v-model="address" />
    </div>
    <div class="list-item">
      <div class="item-top">
        <!-- <span>*</span> -->
        户籍所在地
      </div>
      <input type="text" class="input" placeholder="请输入户籍所在地" v-model="addr" />
    </div>
    <div class="list-item">
      <div class="item-top">
        <span>*</span>
        电话号码
      </div>
      <input type="text" class="input" placeholder="请输入真实有效的电话号码" v-model="telphones" />
    </div>
    <!-- 按钮 -->
    <div class="login-btn">
      <van-button type="danger" @click="navNext">下一步，填写服役信息</van-button>
    </div>
    <div class="log-nav">
      <span>已有账号</span>
      <span>去登录</span>
    </div>
    <div class="login-lianxi">
      <a href="tel:85711525">就业创业科联系电话：85711525</a>
    </div>
  </div>
</template>
<script>
import {
  getNationData,
  getPoliticsStatusData,
  upLoad,
  getRegisterInfo
} from "@/api/apiData";
import { mapMutations, mapState } from "vuex";
import { Toast } from "vant";
import { regIdCard, regTelphone } from "@/until/reg";
export default {
  name: "register",
  components: {},
  data() {
    return {
      area: "",
      name: "", //姓名
      radio: "0", //性别选择
      activeIcon: require("@/assets/img/user/select.png"),
      inactiveIcon: require("@/assets/img/user/unselect.png"),
      showPicker: false, //学历选择弹窗
      nation: "", //民族
      columns: [],
      politics: "", //政治面貌
      identityList: [],
      identity: false,
      address: "",
      addr: "",
      types: false, //证件
      // typeList: ["身份证", "士官证", "团员证"], //证件类型列表
      certificate: "",
      telphones: "", //电话号码
      politicsId: "",
      nationId: "",
      idNum: "",
      logoImg: [],
      logo: [],
      upload: true //logo区域
    };
  },
  computed: {
    ...mapState([
      "companyAddress",
      "telphone",
      "password",
      "token",
      "userParams"
    ])
  },
  methods: {
    ...mapMutations(["userRegister", "selectAddress"]),
    goBack() {
      this.$router.back();
    },
    checkArea() {
      this.$router.push({
        name: "Address"
      });
    },
    navNext() {
      const that = this;
      let {
        name,
        radio,
        nationId,
        politicsId,
        idNum,
        telphones,
        companyAddress,
        address,
        addr,
        logo
      } = that;
      if (logo[0] =='') {
        Toast.fail({
          message: "请上传个人的电子照片",
          forbidClick: true
        });
        return;
      }
      if (name.replace(/[, ]/g, "").length == 0) {
        Toast.fail({
          message: "请输入真实姓名",
          forbidClick: true
        });
        return;
      }
      if (radio == "0") {
        Toast.fail({
          message: "请选择性别",
          forbidClick: true
        });
        return;
      }
      if (nationId === "") {
        Toast.fail({
          message: "请选择民族",
          forbidClick: true
        });
        return;
      }
      if (politicsId === "") {
        Toast.fail({
          message: "请选择政治面貌",
          forbidClick: true
        });
        return;
      }
      if (!regIdCard(idNum)) {
        Toast.fail({
          message: "请正确有效的身份证号码",
          forbidClick: true
        });
        return;
      }
      if (companyAddress.length == 0) {
        Toast.fail({
          message: "请选择所在地区",
          forbidClick: true
        });
      }
      if (address.replace(/[, ]/g, "").length == 0) {
        Toast.fail({
          message: "请填写详细住址",
          forbidClick: true
        });
        return;
      }
      // if (addr.replace(/[, ]/g, "").length == 0) {
      //   Toast.fail({
      //     message: "请填写户籍所在地",
      //     forbidClick: true
      //   });
      //   return;
      // }
      if (!regTelphone(telphones)) {
        Toast.fail({
          message: "请正确有效的手机号码",
          forbidClick: true
        });
        return;
      }
      if (that.token == 2) {
        this.userRegister([
          logo,
          name,
          radio,
          nationId,
          politicsId,
          idNum,
          companyAddress[1],
          address,
          addr,
          telphones,
          that.userParams[9],
          that.userParams[10],
          that.userParams[11],
          that.userParams[12],
          that.userParams[13],
          that.userParams[14],
          that.userParams[15],
          that.userParams[16],
          that.userParams[17],
          that.userParams[18],
          that.userParams[19]
        ]);
      } else {
        this.userRegister([
          logo,
          name,
          radio,
          nationId,
          politicsId,
          idNum,
          companyAddress[1],
          address,
          addr,
          telphones
        ]);
      }
      this.$router.push({
        name: "soliderInfo"
      });
    },
    // logo上传成功后的回调函数
    afterRead(file) {
      this.upload = false;
      upLoad({ file: file.content }).then(res => {
        if (res.code == 1) {
          this.logo[0] = res.data.path; //logo
        } else {
          Toast(res.msg);
        }
      });
    },
    // 删除logo
    colse(file) {
      const that = this;
      that.logo[0] = "";
      this.upload = true;
    },
    // 获取选择项数据
    getCheckedData() {
      const that = this;
      // 获取民族
      getNationData().then(res => {
        if (res.code == 1) {
          that.columns = res.data;
          // 获取政治面貌数据类型
          getPoliticsStatusData().then(result => {
            if (result.code == 1) {
              that.identityList = result.data;
              if (this.token == 2) {
                // 获取注册信息
                this.getRegisterMessage();
              }
            }
          });
        }
      });
    },
    // 民族
    onConfirm(val) {
      this.nation = val.name;
      this.nationId = val.value;
      this.showPicker = false;
    },
    // 政治面貌
    identitySelect(val) {
      this.politics = val.name;
      this.politicsId = val.value;
      this.identity = false;
    },
    // 获取注册信息
    getRegisterMessage() {
      const that = this;
      let obj = {
        username: that.telphone,
        password: that.password
      };
      getRegisterInfo(obj).then(res => {
        if (res.code == 1) {
          let info = res.data;
          let arr = [];
          for (let i in info) {
            arr.push(info[i]);
          }

          // 头像
          if (arr[0] != "") {
            that.upload = false;
            that.logo[0] = arr[0];
            that.logoImg[0] = { url: arr[0] }; //logo
          }
          // 姓名
          that.name = arr[1];
          // 性别
          that.radio = arr[2];
          // 民族
          that.columns.forEach(item => {
            if (item.value == arr[3]) {
              that.nation = item.name;
              that.nationId = item.value;
            }
          });
          //  政治面貌

          that.identityList.forEach(its => {
            if (its.value == arr[4]) {
              that.politics = its.name;
              that.politicsId = its.value;
            }
          });
          // 身份证号
          that.idNum = arr[5];
          // 所在地区
          that.selectAddress([arr[20], arr[19]]);
          // 详细住址
          that.address = arr[6];
          // 户籍所在地
          that.addr = arr[7];
          // 电话号码
          that.telphones = arr[8];
          that.userRegister(arr);
        } else {
          Toast(res.msg);
        }
      });
    },
    // 证件类型
    typeSelect(val) {
      this.types = false;
      this.certificate = val;
    }
  },
  created() {
    this.$nextTick(() => {
      this.getCheckedData();
    });
  },
  mounted() {}
};
</script>
<style lang='less' scoped>
.list-item {
  display: flex;
  flex-direction: column;
  padding: 0.3rem;
  .item-top {
    font-size: 0.3rem;
    font-weight: 600;
    span {
      color: red;
    }
  }
  .input {
    width: 100%;
    padding: 0.19rem 0;
    border-bottom: 0.01rem solid #dedede !important;
    font-size: 0.3rem;
    background: #fff;
  }
  .input::-webkit-input-placeholder {
    font-size: 0.24rem;
    font-weight: 400;
    color: rgba(204, 204, 204, 1);
  }
  .encrypt-right {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0.23rem 0;
    border-bottom: 0.01rem solid #dedede;
    span {
      font-size: 0.3rem;
      line-height: 0.45rem;
      color: #cccccc;
    }
  }

  /deep/.van-radio-group {
    display: flex;

    .van-radio {
      flex: 1;
      display: flex;
      align-items: center;
      .img-icon {
        width: 0.4rem;
        height: 0.4rem;
      }
      .van-radio__label {
        font-size: 0.3rem;
        line-height: 0.42rem;
        color: #cccccc;
      }
      .checked {
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}
.van-uploader {
  left: 50%;
  transform: translateX(-50%);
}
.add-img {
  margin: 0.2rem 0 0 0.32rem;
  width: 1.48rem;
  height: 1.48rem;
  border-radius: 0.12rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 0.02rem dashed #e6e6e6;
  .add {
    width: 0.48rem;
    height: 0.48rem;
  }
  p {
    font-size: 0.22rem;

    font-weight: 400;
    line-height: 0.3rem;
    color: rgba(153, 153, 153, 1);
  }
}
.login-btn {
  width: 90%;
  margin: 0.9rem auto 0;
  .van-button {
    width: 100%;
    background: rgba(255, 67, 67, 1);
    border-radius: 0.08rem;
  }
}
.log-nav {
  margin: 0.4rem 5% 0.1rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  span:nth-child(2) {
    color: #ff4343;
    padding-left: 0.1rem;
  }
  span:nth-child(2)::after {
    content: "";
    display: block;
    width: 0.8rem;
    height: 1px;
    background: rgba(255, 67, 67, 1);
    margin-left: 1.1rem;
  }
}
.login-lianxi {
  font-size: 0.3rem;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin: 0.3rem 5% 0.5rem;
}
</style>